// extracted by mini-css-extract-plugin
module.exports = {"container":"authorSocialLinks_container___swS9"};